// extracted by mini-css-extract-plugin
module.exports = {"icon":"MInfo_icon__3Jr5Y"};